
import {Component, Inject, Input} from 'ng-metadata/core';
import {CitationTrailsService} from './citationTrails.service';
import {CitationTrailsBreadcrumbsService} from './citationTrailsBreadcrumbs.service';

import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {SeedData} from './citationTrailsBreadcrumbs.directive';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';

const _flatten = require('lodash/flatten');
const _escape = require('lodash/escape');

@Component({
	'selector': 'prm-citation-trails-indication',
	templateUrl: 'components/search/citationTrails/citation-trails-indication.html',
})


export class PrmCitationTrailsIndication {
	@Input() public record 	: PrimoResponse.IExtendedDoc;
	@Input() public type	: string;
	@Input() isFullView :boolean;
	@Input() isOverlayFullView: boolean;

	public CITATION_TRAILS_STATE = STATE_NAMES.CITATION_TRAILS;

	constructor(private citationTrailsService:CitationTrailsService,
				@Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
				@Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private ctBreadcrumbsService: CitationTrailsBreadcrumbsService,
                private primolyticsService: PrimolyticsService,
				@Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
				@Inject('$location') private $location: ng.ILocationService){
	}


	public onClick($event, type){
		this.type === 'citing' ? this.sendCitingBeacon() :this.sendCitedbyBeacon();
		$event.stopPropagation();
		this.$mdDialog.hide(); //For full-view page
        if (this.$state.current.name === this.CITATION_TRAILS_STATE){
            //$event.preventDefault();
            let data= this.citationsStateParams;
            this.$rootScope.$broadcast('addCitationEvent', {params: data});/*this event bubbles. Maybe there is an angular 2 way to do this?
                                                                 I had to use a broadcast from the root scope since I need to catch events fired from within the full view md-dialog*/

        													}
        else{

        }
	}

    public escapeString(str) {
        return _escape(str)
    }

	@beacon({'p':'brief', 'op': 'CitationsLink'})
	private sendCitingBeacon(){
	}

	@beacon({'p':'brief', 'op': 'CitedByLink'})
	private sendCitedbyBeacon(){
	}

    private getRecordTitle() {
        return this.record.pnx.display['title'][0];
    }

    private removeTNprefixFromQuery(value){
        return (value && value.startsWith('TN_')) ? value.replace('TN_', '') : value;
    }

	public getLabel() {
		return this.type === 'citing' ? 'nui.citation_trail.link.citing' : 'nui.citation_trail.link.citedin';
	}

	public isCitationStatTooltip() {
		if  (this.isCitationTrails() || this.isbrief()) {
			return this.type === 'citing' ? 'nui.citation_trail.link.citing.tooltip' : 'nui.citation_trail.link.citedin.tooltip';
		}
	}


	public getIconName(){
		return this.type === 'citing' ? 'citing' : 'citedBy';
	}

	get citationsStateParams(){
		let facetType = this.type === 'citing' ? 'citing' : 'citedby';
		let frbrgroupid = this.citationTrailsService.fetchFrbrGroupId(this.record);
		let activeSeed = this.record.pnx.control.recordid + ',' + facetType + ',' + frbrgroupid;
		let seedIdValues = this.$stateParams.seed_id ? [this.$stateParams.seed_id] : [];
        seedIdValues= _flatten(seedIdValues);
        seedIdValues= seedIdValues.slice(0, this.ctBreadcrumbsService.seeds.getActiveLevel() + 1);
		seedIdValues.push(activeSeed);

		let params = {
			query			: this.$stateParams.query || 'any,contains,'+ this.removeTNprefixFromQuery(this.record.pnx.control.recordid[0]),
			tab				: this.$stateParams.tab,
			search_scope	: this.$stateParams.search_scope,
			lang			: this.$stateParams.lang,
			adaptor			: this.$stateParams.adaptor,
			vid				: this.$stateParams.vid,
			facet			: facetType + ',exact,' + frbrgroupid,
			ctType			: this.type,
			docid			: this.$stateParams.docid,
			came_from       : 'citationTtrailsIndication',
            seed_id			: seedIdValues,
            offset          : 0,
			seedInfo 		: new SeedData(facetType, this.getDocTitle(), this.getDocCreator(),frbrgroupid, this.record.pnx.control.recordid[0], this.record),
			citationTrailFilterByAvailability: this.$location.search().citationTrailFilterByAvailability,
		};
		return params;
	}


	public getDocTitle(){
		let title =  this.record.pnx.display.title ||
			this.record.pnx.display.atitle ||
			this.record.pnx.display.btitle;

		return encodeURIComponent(title);
	}

	public getDocCreator(){
		return encodeURIComponent(this.record.pnx.display.creator);
	}

	 public isfullView() {
	 	return this.$state.current.name === STATE_NAMES.FULL_DISPLAY;
	 }

    public isbrief() {
        return this.$state.current.name === STATE_NAMES.SEARCH;
    }

	public isCitationTrails() {
		return this.$state.current.name === STATE_NAMES.CITATION_TRAILS;
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsIndication.directive.ts